import React from "react";
import * as R from "ramda";
import { Content } from "@worcket/common/components/layout";
import { connect } from "react-redux";
import { compose, withProps } from "recompose";
import { withTranslation } from "react-i18next";
import { spinWhile } from "@worcket/common/hocs";
import { Tabs, Icon } from "antd";
import { Route } from "react-router-dom";

import Page from "../../components/display/Page";
import Header from "../../components/structure/Header";
import Spinner from "../../components/feedback/Spinner";
import { FETCH_USER_PROFILE } from "../../store/actions/user";
import { getOptimizedImage } from "../../utils/images";
import UserSocialAccounts from "../Company/SocialAccounts/UserSocialAccounts";

import ProfileForm from "./ProfileForm";
import PasswordForm from "./PasswordForm";
import Calendar from "./Calendar";

import styled from "styled-components/macro";

const { TabPane } = Tabs;

const StyledTabs = styled(Tabs)`
  margin: 16px !important;

  .ant-tabs-tab {
    margin-right: 4px;
  }

  .ant-tabs-tab-active {
    background: #fff;
    border-color: #fff !important;
  }

  .ant-tabs-content {
    margin-top: -16px;
  }

  .ant-tabs-tabpane {
    background: #fff;
    padding: 24px 16px !important;
  }
`;

const User = ({ t, user, history, match: routeMatch }) => {
  return (
    <Page>
      <Content>
        <Header
          image={getOptimizedImage(user.avatar)}
          title={user.name}
          subtitle={user.email}
          tags={user.roles}
        >
          <Calendar history={history} />
        </Header>
      </Content>
      <Route
        path={`${routeMatch.url}/:tab?`}
        render={({ match: tabMatch, history }) => {
          return (
            <StyledTabs
              defaultActiveKey={tabMatch.params.tab}
              animated={false}
              type="card"
              onChange={key => {
                history.push(`${routeMatch.url}/${key}`);
              }}
            >
              <TabPane
                tab={
                  <span>
                    <Icon type="setting" />
                    {t("user:tabs.profile")}
                  </span>
                }
                key="perfil"
              >
                <ProfileForm profile={user} />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="key" />
                    {t("user:tabs.security")}
                  </span>
                }
                key="seguridad"
              >
                <PasswordForm />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="link" />
                    {t("user:tabs.socialMedia")}
                  </span>
                }
                key="redes-sociales"
              >
                <UserSocialAccounts accounts={user.socialAccounts} />
              </TabPane>
            </StyledTabs>
          );
        }}
      />
    </Page>
  );
};

const enhancer = compose(
  withTranslation(["catalogs", "user"]),
  connect(
    R.applySpec({
      user: R.propOr({}, "user")
    })
  ),
  withProps(({ t, ...props }) =>
    R.evolve(
      {
        user: {
          roles: R.map(role => t(`catalogs:userRoles.${role}`))
        }
      },
      props
    )
  ),
  spinWhile(FETCH_USER_PROFILE, { initial: true }, <Spinner />)
);

export default enhancer(User);
